import React from 'react'
import AssignPeselNumberForm from './AssignPeselNumberForm'
import PropTypes from 'prop-types'

const AssignPeselNumber = ({ handleSubmitAssign, assignPeselNumber }) => {
  return (
    <AssignPeselNumberForm
      onSubmit={handleSubmitAssign}
      fetching={assignPeselNumber.fetching}
    />
  )
}

AssignPeselNumber.propTypes = {
  handleSubmitAssign: PropTypes.func.isRequired,
  assignPeselNumber: PropTypes.object.isRequired
}

export default AssignPeselNumber
